import { AppState } from "src/store/index";
import { createSelector } from "reselect";

const getTourState = (state: AppState) => state.tour;

export const getTourStepType = createSelector(
  getTourState,
  (state) => state.stepType
);

export const getTourCurrentStep = createSelector(
  getTourState,
  (state) => state.currentStep
);

export const getTourOpen = createSelector(getTourState, (state) => state.open);

export const getTourPendingStep = createSelector(
  getTourState,
  (state) => state.pendingStep
);

export const getTourDialogReady = createSelector(
  getTourState,
  (state) => state.dialogReady
);
